import { Component, OnDestroy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { BaseApi } from 'src/backend/api/base-api';
@Component({
    selector: 'btn-cell-rendererAuditTaskTrackerApproval',
    template: `
    <!-- <button *ngIf="params.data" mat-mini-fab color="accent" pTooltip="View" tooltipPosition="top" style="background: #3f38c8;"  (click)="onClickView($event)">
    <mat-icon>remove_red_eye</mat-icon>
    </button> -->
    <button *ngIf="(params.data.Status!='Approve')" mat-mini-fab color="accent" pTooltip="Edit" tooltipPosition="top" style="background: #3f38c8;"  (click)="onClickUpdate($event)">
    <mat-icon>edit</mat-icon>
    </button>
    <button *ngIf="params.data && params.data.IsPartialyExecute != true && (params.data.Status!='Approve' && params.data.Status!='Executed')" mat-mini-fab color="accent" pTooltip="Approve" tooltipPosition="top" style="background: #0fbb83;"  (click)="onClickApprove($event)">
    <mat-icon>check</mat-icon>
    </button>
    <button *ngIf="params.data && params.data.IsPartialyExecute != true && (params.data.Status!='Reject' && params.data.Status!='Executed')" mat-mini-fab color="accent" pTooltip="Reject" tooltipPosition="top" style="background: #ed0933;"  (click)="onClickReject($event)">
    <mat-icon>close icon</mat-icon>
    </button>
  `
})
export class BtnRendererAuditTaskTrackerApproval implements ICellRendererAngularComp, OnDestroy {
    params: any;
    loggedUser: any;
    constructor(private baseApi: BaseApi,) { }
    refresh(params: any): boolean {
        throw new Error('Method not implemented.');
    }
    agInit(params: any): void {
        // this.loggedUser = JSON.parse(localStorage.getItem('user'));
        //this.loggedUser = this.baseApi.getUserSession();
        this.params = params;
    }
    // onClickView($event: any): any {

    //     if (this.params.onClickView instanceof Function) {
    //         const params = {
    //             event: $event,
    //             rowData: this.params.node.data
    //         };
    //         this.params.onClickView(params);
    //     }
    // }
    onClickUpdate($event: any): any {

        if (this.params.onClickUpdate instanceof Function) {
            const params = {
                event: $event,
                rowData: this.params.node.data
            };
            this.params.onClickUpdate(params);
        }
    }
    onClickApprove($event: any): any {

        if (this.params.onClickApprove instanceof Function) {
            const params = {
                event: $event,
                rowData: this.params.node.data
            };
            this.params.onClickApprove(params);
        }
    }
    onClickReject($event: any): any {

        if (this.params.onClickReject instanceof Function) {
            const params = {
                event: $event,
                rowData: this.params.node.data
            };
            this.params.onClickReject(params);
        }
    }
    ngOnDestroy(): any {

    }
}